export const isMagicFrameInEditing = () => {
  const activeObject = window.canvas.getActiveObject();

  if (!activeObject) {
    return false;
  }

  if (activeObject.type === 'image' && activeObject._magicFrame) {
    return activeObject._magicFrame.isEditing;
  }

  return activeObject.isEditing;
};
